import { render, staticRenderFns } from "./EditableFormatSummaryDocumentKindFilter.vue?vue&type=template&id=00b52852&scoped=true&"
import script from "./EditableFormatSummaryDocumentKindFilter.vue?vue&type=script&lang=ts&"
export * from "./EditableFormatSummaryDocumentKindFilter.vue?vue&type=script&lang=ts&"
import style0 from "./EditableFormatSummaryDocumentKindFilter.vue?vue&type=style&index=0&id=00b52852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b52852",
  null
  
)

export default component.exports